import React, { useState } from 'react';
import { useNavigate, Link } from 'react-router-dom';
import api from '../api/api'; 
import styles from '../Home.module.css';
import logoCafe from '../assets/logoCafe.png';

function Contacto() {
    const navigate = useNavigate();
    
    const [formData, setFormData] = useState({
        nombre: '',
        email: '',
        mensaje: ''
    });
    
    const [enviado, setEnviado] = useState(false);
    const [loading, setLoading] = useState(false);

    const handleChange = (e) => {
        setFormData({
            ...formData,
            [e.target.name]: e.target.value
        });
    };

    const handleSubmit = async (e) => {
        e.preventDefault();
        setLoading(true);

        try {
            await api.post('/contact', formData);
            
            setEnviado(true);
            
            setTimeout(() => {
                navigate('/');
            }, 3000);

        } catch (error) {
            console.error("Error enviando mensaje", error);
            alert("Hubo un problema al enviar el mensaje. Intenta nuevamente.");
        } finally {
            setLoading(false);
        }
    };

// src/pages/Contacto.jsx

// ... (dentro de la función Contacto)

    // --- ESTILOS CONSISTENTES CON EL DASHBOARD ---

    // 1. CSS Global COMPLETO para Inyección
    const fullCssInjection =`
        @keyframes moveDots {
            0% { background-position: 0 0; }
            100% { background-position: 400px 400px; }
        }
        /* Esta animación usa puntos blancos semi-transparentes sobre el fondo oscuro */
        .animated-background-dots::before {
            content: '';
            position: absolute;
            top: 0;
            left: 0;
            width: 100%;
            height: 100%;
            background-image: radial-gradient(#ffffff20 1px, transparent 1px);
            background-size: 40px 40px;
            animation: moveDots 60s linear infinite;
            z-index: 0;
        }
    `;

    const PAGE_CONTAINER = { 
        minHeight: '100vh', 
        // 🟢 FIX: Usar el color de fondo sólido Verde Sierra
        background: '#2E5B2E', 
        // ❌ REMOVIDO: backgroundSize y animation (eran del gradiente anterior)
        display: 'flex', 
        flexDirection: 'column', 
        alignItems: 'center', 
        justifyContent: 'center',
        position: 'relative',
        overflow: 'hidden'
    };
    
    const navBarButtonStyle = { 
        // 🟢 FIX: Usar los estilos definidos en el tema Xavana Café
        background: 'transparent', 
        color: '#FFFFFF', 
        padding: '10px 25px', 
        borderRadius: 8, 
        border: '1px solid #FFFFFF50', 
        fontWeight: 'bold',
        cursor: 'pointer',
        textDecoration: 'none',
        transition: 'all 0.3s ease',
        boxShadow: 'none',
        ':hover': {
            background: '#C19A6B', 
            color: '#FFFFFF',
            transform: 'translateY(-1px)'
        }
    };
// ...
    // Tarjeta del Formulario
    const formCardStyle = { 
        width: 800, // Aumentamos ancho para el layout de dos columnas del mockup
        background: '#FFFFFF', // Fondo Blanco
        backdropFilter: 'none', 
        borderRadius: 20, 
        border: 'none', 
        padding: 40, 
        boxShadow: '0 12px 30px rgba(0,0,0,0.2)', 
        display: 'flex', 
        flexDirection: 'column', 
        alignItems: 'center',
        zIndex: 10, 
        color: '#333333' 
    };
    
    // Título en Recuadro (Ahora es un banner ancho Verde Sierra)
    const titleBoxStyle = {
        background: '#2E5B2E', // Verde Sierra
        color: '#FFFFFF', 
        borderRadius: 0, // Quitamos radio para que se vea como banner
        marginBottom: 0, 
        padding: '30px 0 20px 0',
        width: '100%',
        textAlign: 'center',
        fontWeight: 'bold',
        fontSize: 32,
        letterSpacing: '0.5px',
        boxShadow: 'none',
    };


    const inputStyle = { 
        width: '100%', 
        padding: 14, 
        marginBottom: 25, 
        borderRadius: 5, 
        background: '#FFFFFF', 
        fontSize: 18, 
        border: '1px solid #C19A6B', // Borde Cantera Pink
        color: '#333333',
        transition: 'border-color 0.3s ease',
        boxShadow: 'none',
        fontFamily: 'inherit'
    };
    
    // Botón Principal (Cantera Pink)
    const submitButtonStyle = { 
        width: '100%', 
        background: loading ? '#C19A6B' : '#C19A6B', 
        color: loading ? '#FFFFFF' : '#FFFFFF', 
        padding: 18, 
        borderRadius: 8, 
        fontWeight: 'bold', 
        fontSize: 20, 
        border: 'none', 
        marginTop: 15,
        cursor: loading ? 'not-allowed' : 'pointer',
        transition: 'background 0.3s ease, transform 0.2s ease',
        boxShadow: '0 5px 15px rgba(193, 154, 107, 0.4)',
        opacity: loading ? 0.8 : 1,
        ':hover': {
            background: loading ? '#C19A6B' : '#2E5B2E',
            transform: loading ? 'none' : 'translateY(-2px)'
        }
    };
    
    const labelStyle = { 
        marginBottom: 5, 
        display: 'block', 
        fontWeight: 'bold', 
        color: '#333333', // Etiqueta Charcoal Grey
        fontSize: 16 
    };
    
    // Contenedor para la información de contacto a la izquierda
    const contactInfoStyle = {
        flex: 1, 
        padding: '0 30px 0 0', 
        borderRight: '1px solid #EAEAEA',
        color: '#333333',
        fontSize: 16
    };
    
    const contactDetailStyle = {
        display: 'flex', 
        alignItems: 'center', 
        gap: 15, 
        marginBottom: 20
    };


    return (
        <div style={PAGE_CONTAINER} className="animated-background-dots">
            {/* 1. Inyectar Keyframes y Pseudo-Elemento para la animación de fondo */}
            <style>{fullCssInjection}</style>

            {/* Barra superior (Alineación con el mockup) */}
            <div style={{ width: 800, display: 'flex', justifyContent: 'flex-end', alignItems:'center', marginBottom: 20, zIndex: 10 }}>

                <Link to="/" style={navBarButtonStyle}>Inicio</Link>
            </div>
            
            {/* Card central */}
            <div style={formCardStyle}>
                
                {/* Título y Subtítulo - Banner Verde */}
                <div style={titleBoxStyle}>
                    <div>CONTÁCTANOS</div>
                    <div style={{fontSize: 18, fontWeight: 'normal', marginTop: 10}}>
                        Llevemos el mejor café a tu empresa u hotel en Querétaro.
                    </div>
                </div>
                
                {enviado ? (
                    <div style={successStyle}>
                        <h3 style={{marginTop:0}}>¡Mensaje Enviado! ✅</h3>
                        <p>Gracias por escribirnos. Te responderemos a la brevedad.</p>
                        <small>Redirigiendo al inicio...</small>
                    </div>
                ) : (
                    <div style={{ width: '100%', display: 'flex', padding: '40px 0' }}>
                        
                        {/* COLUMNA IZQUIERDA: DATOS DE CONTACTO */}
                        <div style={contactInfoStyle}>
                            <h4 style={{color: '#2E5B2E', marginBottom: 20, fontSize: 20}}>Datos de Contacto</h4>
                            
                            <div style={contactDetailStyle}>
                                <span role="img" aria-label="phone" style={{color: '#C19A6B', fontSize: 24}}>📞</span>
                                <div>
                                    <div style={{fontWeight: 'bold'}}>Ventas QRO:</div>
                                    <div>(442) 614-1234</div>
                                </div>
                            </div>
                            
                            <div style={contactDetailStyle}>
                                <span role="img" aria-label="email" style={{color: '#C19A6B', fontSize: 24}}>✉️</span>
                                <div>
                                    <div style={{fontWeight: 'bold'}}>Email B2B:</div>
                                    <div>contacto.xavana@gmail.com</div>
                                </div>
                            </div>
                        </div>

                        {/* COLUMNA DERECHA: FORMULARIO */}
                        <form onSubmit={handleSubmit} style={{ flex: 1, paddingLeft: 30 }}>
                            <label style={labelStyle}>Nombre Completo</label>
                            <input type="text" name="nombre" value={formData.nombre} onChange={handleChange} style={inputStyle} required placeholder="Tu nombre" />
                            
                            <label style={labelStyle}>Correo Electrónico</label>
                            <input type="email" name="email" value={formData.email} onChange={handleChange} style={inputStyle} required placeholder="contacto@ejemplo.com" />
                            
                            <label style={labelStyle}>Mensaje</label>
                            <textarea name="mensaje" value={formData.mensaje} onChange={handleChange} style={{ ...inputStyle, minHeight: 120, resize: 'vertical' }} required placeholder="Escribe tu mensaje aquí..." />
                            
                            <button type="submit" disabled={loading} style={submitButtonStyle}>
                                {loading ? 'Enviando...' : 'ENVIAR MENSAJE'}
                            </button>
                        </form>
                    </div>
                )}
            </div>
        </div>
    );
}

export default Contacto;